module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/mikayla-mannara-69aaab688fd56631dd306786c5a8ed99.jpg";